export default [
  {"id":"candidate-family-index","index":true,"component":"FamilyApp","guard":"none"},
  {"id":"candidate-family-activity","path":"activity","component":"FamilyApp","guard":"none"},
  {"id":"candidate-family-insights","path":"insights","component":"FamilyApp","guard":"none"},
  {"id":"candidate-family-plan","path":"plan","component":"FamilyApp","guard":"none"},
  {"id":"candidate-family-connections","path":"connections","component":"FamilyApp","guard":"none"},
  {"id":"candidate-family-settings","path":"settings","component":"FamilyApp","guard":"none"},
  {"id":"candidate-family-habits","path":"habits","component":"FamilyApp","guard":"none"},
  {"id":"candidate-family-report","path":"reports/:reportKey","component":"FamilyApp","guard":"none"},
  {"id":"candidate-family-fallback","path":"*","component":"ProductNotFound","guard":"none"}
];
